var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMassTort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240.51 169.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:12px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.26,75.29v-1.96c0-12.33-9.55-22.42-21.64-23.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.09,75.29v-1.96c0-12.33,9.53-22.41,21.63-23.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.32,
    y1: 140.05,
    x2: 82.02,
    y2: 140.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.26,31.09c0,7.56-3.35,14.34-8.64,18.94,0,0,0,.01,0,0-4.4,3.83-10.15,6.15-16.44,6.15s-12.04-2.32-16.44-6.15c-.01,.01-.01,0-.01,0-5.3-4.6-8.64-11.38-8.64-18.94,0-13.86,11.23-25.09,25.09-25.09s25.09,11.23,25.09,25.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.26,75.29v-1.96c0-12.33,9.53-22.41,21.63-23.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.78,50.03c12.1,.88,21.64,10.97,21.64,23.3v1.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 158.37,
    y1: 141.53,
    x2: 158.31,
    y2: 141.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.42,31.09c0,7.56-3.34,14.34-8.64,18.94,0,0,0,.01,0,0-4.4,3.83-10.15,6.15-16.44,6.15s-12.03-2.32-16.43-6.15c-.01,.01-.01,0-.01,0-5.3-4.6-8.64-11.38-8.64-18.94,0-13.86,11.23-25.09,25.08-25.09s25.09,11.23,25.09,25.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.51,142.63v21.16h-76.17v-21.16c0-.37,.01-.74,.03-1.1,.54-11.82,9.86-21.35,21.6-22.2h.02c4.4,3.83,10.14,6.14,16.43,6.14s12.03-2.31,16.43-6.14h.02c12.09,.88,21.64,10.96,21.64,23.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.51,100.38c0,7.57-3.35,14.36-8.66,18.95-4.4,3.83-10.14,6.14-16.43,6.14s-12.03-2.31-16.43-6.14c-5.31-4.59-8.66-11.38-8.66-18.95,0-13.85,11.23-25.09,25.09-25.09s25.09,11.24,25.09,25.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.51,119.33h.02c11.24,.82,20.28,9.58,21.49,20.72,.1,.85,.15,1.71,.15,2.58v21.16H6v-21.16c0-12.33,9.53-22.42,21.63-23.3h.02"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 44.08,
    cy: 100.38,
    r: 25.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.68,119.33h.02c11.24,.82,20.28,9.58,21.49,20.72,.1,.85,.15,1.71,.15,2.58v21.16H82.16v-21.16c0-12.33,9.53-22.42,21.63-23.3h.02"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 120.25,
    cy: 100.38,
    r: 25.09
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassTort);
export default __webpack_public_path__ + "static/media/massTort.7f259cf80a233da53254c310c6b16ef0.svg";
export { ForwardRef as ReactComponent };